export default "__VITE_ASSET__Bsjc7Y4a__"